import { render, staticRenderFns } from "./HomeBlockStock.vue?vue&type=template&id=532e2a5d&scoped=true"
import script from "./HomeBlockStock.vue?vue&type=script&lang=js"
export * from "./HomeBlockStock.vue?vue&type=script&lang=js"
import style0 from "./HomeBlockStock.vue?vue&type=style&index=0&id=532e2a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e2a5d",
  null
  
)

export default component.exports